<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.moveToLibrary}}</h3>
</div>
<div class="modal-body">
    <form class="form-signin" style="max-width:400px">
        <div class="row">
			<div class="col-xs-12">
			    <p id="libraryLabel" class="text-black">{{LOCALIZATION.library}} </p>
				<select type="text" class="form-control" [(ngModel)]="library" name="librarySelect" aria-labelledby="libraryLabel">
					<option *ngFor="let library of libraries" value="{{library.id}}">{{library.displayName}}</option>
				</select>
				<div class="text-center"><span><em>Choose a new library for the documents.</em></span></div>
			</div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="move()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.move}}
    </button>
</div>